import React, { Component } from "react";
import { connect } from "react-redux";
import Summary from "../components/Summary";
import { updateUserData } from "../../../../actions/user.actions";
import { searchCitiesAutocomplete } from "../../../../actions/cities.actions";
import {
  fetchIndustries,
  getCommuteCities
} from "../../../../actions/dropdowns.actions";

class SummaryContainer extends Component {
  constructor(props) {
    super(props);

    this.memberId = this.props.match.params.memberId;
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.fetchIndustries();
    this.props.getCommuteCities();
  }

  handleSubmit(data) {
    if (data.city && data.city.length > 0) {
      data.city = data.city[0].description;
    }

    if (!this.memberId) {
      this.props.updateUserData(data, "/member/profile", "summary");
    } else {
      const url = /(5|6|7|9)/.test(this.props.user.status_id)
        ? `/admin/member/${this.memberId}/moderation`
        : `/admin/member/approved/${this.memberId}/profile`;

      this.props.updateUserData(data, url, "summary");
    }
  }

  render() {
    return (
      <Summary
        cities={this.props.cities}
        commuteCities={this.props.commuteCities}
        industries={this.props.industries}
        defaultLocation={this.props.defaultLocation}
        isLoading={this.props.isLoading}
        memberId={this.memberId}
        onSubmit={this.handleSubmit}
        searchCitiesAutocomplete={this.props.searchCitiesAutocomplete}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    cities: state.cities.cities.predictions,
    commuteCities: state.dropdowns.commuteCities.data,
    industries: state.dropdowns.industries.data,
    defaultLocation: _.get(state, "user.data.profile.city"),
    isLoading: state.cities.cities.isLoading,
    user: state.user.data
  };
};

const mapDispatchToProps = dispatch => ({
  searchCitiesAutocomplete: query => dispatch(searchCitiesAutocomplete(query)),
  updateUserData: (user, redirect, formName) =>
    dispatch(updateUserData(user, redirect, formName)),
  fetchIndustries: () => dispatch(fetchIndustries()),
  getCommuteCities: () => dispatch(getCommuteCities())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SummaryContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/profile/containers/SummaryContainer.js